import { ChakraV3, Empty, Pagination, Spin } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { PiccoloError } from '../../components/generic/PiccoloError';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { useTemplatesFilterQuery } from '../../graphql/hooks/useTemplatesQuery';
import { usePermission } from '../../hooks/usePermission';
import { useTemplatesFilter } from './hooks/useTemplatesFilter';
import { TemplateCard } from './TemplateCard';
import { TemplateCreateModal } from './TemplateCreateModal';
import { TemplatesFilterControls } from './TemplatesFilterControls';

export const Templates = () => {
  const filter = useTemplatesFilter();

  const createTemplatePermission = usePermission('create', 'template');

  const { isLoading, error, templates, pagination } = useTemplatesFilterQuery(filter);

  const content = P.run(() => {
    if (isLoading) {
      return <Spin />;
    }

    if (error) {
      return <PiccoloError error={error} />;
    }

    if (P.isEmpty(templates)) {
      return <Empty title='No templates found' />;
    }

    return (
      <ChakraV3.Stack gap={4} pb={4}>
        <ChakraV3.HStack gap={4} wrap='wrap'>
          {templates.map((template) => (
            <TemplateCard key={template.id} template={template} />
          ))}
        </ChakraV3.HStack>
        {pagination && (
          <ChakraV3.HStack justify='end'>
            <Pagination {...pagination} />
          </ChakraV3.HStack>
        )}
      </ChakraV3.Stack>
    );
  });

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.HStack align='start'>
          <ChakraV3.Heading size='3xl' fontWeight='bold'>
            Templates
          </ChakraV3.Heading>
          <ChakraV3.Spacer />
          <ChakraV3.Button
            disabled={!createTemplatePermission}
            colorPalette='brand'
            size='sm'
            onClick={() => showModal(TemplateCreateModal)}
          >
            <FaPlus />
            Create a template
          </ChakraV3.Button>
        </ChakraV3.HStack>
      }
    >
      <ChakraV3.Stack gap={8} px={6}>
        <TemplatesFilterControls filter={filter} />
        {content}
      </ChakraV3.Stack>
    </ContentLayout>
  );
};
